import { useCallback, useEffect, useState } from 'react';

const EVENT = 'gara:theme-change';

function readIsDark() {
  return document.documentElement.classList.contains('dark');
}

/** Shared light/dark toggle — stays in sync across every component that uses it. */
export function useTheme() {
  const [isDark, setIsDark] = useState(readIsDark);

  useEffect(() => {
    const sync = () => setIsDark(readIsDark());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);

  const toggleTheme = useCallback(() => {
    const next = !readIsDark();
    document.documentElement.classList.toggle('dark', next);
    try {
      localStorage.setItem('theme', next ? 'dark' : 'light');
    } catch {
      // storage unavailable — theme still applies for this session
    }
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { isDark, toggleTheme };
}
